module.exports = __webpack_public_path__ + "img/logo.657b35d2.png";